import React from 'react';
import { TriangleAlert } from 'lucide-react';

import { cn } from '@dashboard/lib/utils';

function PipingTag({ attributes, children, stale = false }) {
  return (
    <span
      className={cn(
        'border rounded mx-px px-1',
        stale
          ? 'inline-flex items-center gap-1 text-destructive border-destructive bg-red-50 dark:bg-red-500/15 line-through'
          : 'text-foreground border-border bg-muted',
      )}
      data-stale={stale ? 'true' : undefined}
      {...attributes}
    >
      {stale && <TriangleAlert className="size-3 shrink-0" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default PipingTag;
